import cookie from 'cookie-utils-js';
import { mapGetters } from 'vuex';
import { Loading } from 'element-ui';
import { getCheckinStatus, checkin } from '@/api/checkin';
import { loadingIcon } from '@/svg';
import { mixins } from '@/mixins';
import Button from '@/components/Button/Button.vue';
import OperateList from '@/components/OperateList/OperateList.vue';

export default {
  components: {
    OperateList,
    Button
  },
  
  name: 'CheckIn',

  mixins: [mixins],

  data() {
    return {
      loading: true,
      loadingIcon,
      checkInItems: [],
      currentCheckDays: 1,
    }
  },

  computed: {
    ...mapGetters([
      'pageBackgroundColor',
      'cardBackgroundColor',
      'hignlightBorderColor',
      'cardBtnBackgroundColor',
      'primaryBtnBackgroundColor',
      'virtualCurrencyUnit'
    ]),
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      const appid = cookie.get('App-Id') || this.debugAppId;
      const token = cookie.get('token') || this.debugToken;
      const checkinStatusInfo = await getCheckinStatus({
        appid,
        token
      });

      if (checkinStatusInfo.code === 0) {
        this.currentCheckDays = checkinStatusInfo.data.current_check_days;
        this.checkInItems = this.makeCheckItems(checkinStatusInfo.data);
      }
      else {
        this.checkInItems = [];
      }

      this.loading = false;
    },

    async checkinRequest() {
      const appid = cookie.get('App-Id') || this.debugAppId;
      const token = cookie.get('token') || this.debugToken;
      const loading = Loading.service({
        fullscreen: true,
        customClass: 'app-loading',
        background: '#1c1d21'
      });
      const day = this.getCurrentCheckDay(this.currentCheckDays);

      try {
        const res = await checkin({
          appid,
          token,
          id: day.id
        });

        if (res.code === 0) {
          const checkinStatusInfo = await getCheckinStatus({
            appid,
            token
          });

          if (checkinStatusInfo.code === 0) {
            this.currentCheckDays = checkinStatusInfo.data.current_check_days;
            this.checkInItems = this.makeCheckItems(checkinStatusInfo.data);
          }
        }

        this.$message({
          message: 'success',
          type: 'success',
          showClose: false,
          customClass: 'custom-message',
          during: 3000
        });
      }
      catch(err) {
        console.log(err);
        if (err.code === 30009) {
          this.$message({
            message: err.message,
            type: 'error',
            showClose: false,
            customClass: 'custom-message',
            during: 10000
          });
        }
      }
      loading.close();
    },

    refreshCheckinStatus() {

    },

    getNextDay(day) {
      for (let i = 0; i < this.checkInItems.length; i++) {
        if (this.checkInItems[i].id !== day.id) {
          continue;
        }

        if (i === this.checkInItems.length - 1) {
          return this.checkInItems[0];
        }

        this.checkInItems[i + 1];
      }
    },

    getCurrentCheckDay(day) {
      for (let i = 0; i < this.checkInItems.length; i++) {
        if (this.checkInItems[i].day === day) {
          return this.checkInItems[i];
        }
      }
    },

    makeCheckItems(opts) {
      const { current_check_days, rewards } = opts;
      const result = [];

      rewards.forEach((reward) => {
        const temp = {
          id: reward.id,
          day: reward.day,
          gems: reward.gems,
          checked: false,
          validate: false
        };

        if (reward.day < current_check_days) {
          temp.checked = true;
          temp.validate = false;
        }
        else if (reward.day === current_check_days) {
          temp.checked = false;
          temp.validate = true;
        }
        else {
          temp.checked = false;
          temp.validate = false;
        }

        result.push(temp);
      });

      return result;
    },
  }
}
